module.exports = __webpack_public_path__ + "img/back.ede0be6c.png";